import {
  Box,
  Grid,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import { Settings } from '@mui/icons-material';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderIcon from '@mui/icons-material/Folder';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import {
  LinkProps,
  Outlet,
  useMatch,
  useNavigate,
  useResolvedPath,
} from 'react-router-dom';
import useToken from '../hooks/useToken';
import mainLogo from '../assets/images/scoutlage.png';

function CustomLink({ children, to }: LinkProps) {
  let resolved = useResolvedPath(to);
  const navigate = useNavigate();
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <MenuItem
      selected={!!match}
      onClick={() => navigate(to)}
      className="MenuItem"
      style={{ padding: '1rem' }}
    >
      {children}
    </MenuItem>
  );
}

const Layout: React.FC<{}> = ({}) => {
  const { deleteToken } = useToken();

  return (
    <Grid
      container
      spacing={2}
      sx={{ marginTop: 0, background: (t) => t.palette.background.default }}
    >
      <Grid
        item
        md={3}
        sx={{
          height: '100vh',
          background: (t) => t.palette.background.paper,
          borderRadius: '0px 30px 30px 0px',
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent={'space-between'}
          sx={{ color: (t) => t.palette.text.primary, height: '100%' }}
        >
          <Box>
            <Stack
              direction="row"
              alignItems="center"
              sx={{ marginBottom: '2.5rem', padding: '1rem' }}
            >
              <img src={mainLogo} width="50" alt="Scoutlage Logo" />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '24px',
                  lineHeight: '36px',
                  color: '#0077FF',
                }}
              >
                coutlage
              </Typography>
            </Stack>
            <MenuList>
              <CustomLink to="/dashboard">
                <ListItemIcon>
                  <AutoAwesomeMosaicIcon color="primary" fontSize="medium" />
                </ListItemIcon>
                <ListItemText>
                  <span style={{ fontWeight: 'bold' }}>Overview</span>
                </ListItemText>
              </CustomLink>
              <CustomLink to="/dashboard/admins">
                <ListItemIcon>
                  <PeopleAltIcon color="primary" fontSize="medium" />
                </ListItemIcon>
                <ListItemText>
                  <span style={{ fontWeight: 'bold' }}> Admins </span>
                </ListItemText>
              </CustomLink>
              <CustomLink to="/dashboard/add">
                <ListItemIcon>
                  <AddToPhotosIcon color="primary" fontSize="medium" />
                </ListItemIcon>
                <ListItemText>
                  <span style={{ fontWeight: 'bold' }}> Add Resource </span>
                </ListItemText>
              </CustomLink>
              <CustomLink to="/dashboard/requests">
                <ListItemIcon>
                  <DescriptionIcon color="primary" fontSize="medium" />
                </ListItemIcon>
                <ListItemText>
                  <span style={{ fontWeight: 'bold' }}>Requests</span>
                </ListItemText>
              </CustomLink>
              <CustomLink to="/dashboard/resources">
                <ListItemIcon>
                  <FolderIcon color="primary" fontSize="medium" />
                </ListItemIcon>
                <ListItemText>
                  <span style={{ fontWeight: 'bold' }}> Resources </span>
                </ListItemText>
              </CustomLink>
              <CustomLink to="/dashboard/settings">
                <ListItemIcon>
                  <Settings color="primary" fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Settings</ListItemText>
              </CustomLink>
            </MenuList>
          </Box>
          <Box
            sx={{ padding: '1rem', cursor: 'pointer', width: 'max-content' }}
            onClick={() => {
              deleteToken();
              window.location.reload();
            }}
          >
            <svg
              width="119"
              height="27"
              viewBox="0 0 119 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M44.2246 17.0352C44.2246 18.3242 43.7591 19.3398 42.8281 20.082C41.9036 20.8242 40.6146 21.1953 38.9609 21.1953C37.4375 21.1953 36.0898 20.9089 34.918 20.3359V17.5234C35.8815 17.9531 36.6953 18.2559 37.3594 18.4316C38.0299 18.6074 38.6419 18.6953 39.1953 18.6953C39.8594 18.6953 40.3672 18.5684 40.7188 18.3145C41.0768 18.0605 41.2559 17.6829 41.2559 17.1816C41.2559 16.9017 41.1777 16.6543 41.0215 16.4395C40.8652 16.2181 40.6341 16.0065 40.3281 15.8047C40.0286 15.6029 39.4134 15.2806 38.4824 14.8379C37.61 14.4277 36.9557 14.0339 36.5195 13.6562C36.0833 13.2786 35.735 12.8392 35.4746 12.3379C35.2142 11.8366 35.084 11.2507 35.084 10.5801C35.084 9.31706 35.5104 8.32422 36.3633 7.60156C37.2227 6.87891 38.4076 6.51758 39.918 6.51758C40.6602 6.51758 41.3665 6.60547 42.0371 6.78125C42.7142 6.95703 43.4206 7.20443 44.1562 7.52344L43.1797 9.87695C42.418 9.56445 41.7865 9.34635 41.2852 9.22266C40.7904 9.09896 40.3021 9.03711 39.8203 9.03711C39.2474 9.03711 38.8079 9.17057 38.502 9.4375C38.196 9.70443 38.043 10.0527 38.043 10.4824C38.043 10.7493 38.1048 10.9837 38.2285 11.1855C38.3522 11.3809 38.5475 11.5729 38.8145 11.7617C39.0879 11.944 39.7292 12.276 40.7383 12.7578C42.0729 13.3958 42.9876 14.0371 43.4824 14.6816C43.9772 15.3197 44.2246 16.1042 44.2246 17.0352ZM46.4512 7.25977C46.4512 6.28971 46.9915 5.80469 48.0723 5.80469C49.153 5.80469 49.6934 6.28971 49.6934 7.25977C49.6934 7.72201 49.5566 8.08333 49.2832 8.34375C49.0163 8.59766 48.6126 8.72461 48.0723 8.72461C46.9915 8.72461 46.4512 8.23633 46.4512 7.25977ZM49.5566 21H46.5781V10.082H49.5566V21ZM62.1934 10.082V11.5957L60.4844 12.0352C60.7969 12.5234 60.9531 13.0703 60.9531 13.6758C60.9531 14.8477 60.543 15.7624 59.7227 16.4199C58.9089 17.071 57.776 17.3965 56.3242 17.3965L55.7871 17.3672L55.3477 17.3184C55.0417 17.5527 54.8887 17.8132 54.8887 18.0996C54.8887 18.5293 55.4355 18.7441 56.5293 18.7441H58.3848C59.5827 18.7441 60.4941 19.0013 61.1191 19.5156C61.7507 20.0299 62.0664 20.7852 62.0664 21.7812C62.0664 23.0573 61.5326 24.0469 60.4648 24.75C59.4036 25.4531 57.877 25.8047 55.8848 25.8047C54.3613 25.8047 53.196 25.5378 52.3887 25.0039C51.5879 24.4766 51.1875 23.7344 51.1875 22.7773C51.1875 22.1198 51.3926 21.5697 51.8027 21.127C52.2129 20.6842 52.8151 20.3685 53.6094 20.1797C53.3034 20.0495 53.0365 19.8379 52.8086 19.5449C52.5807 19.2454 52.4668 18.9297 52.4668 18.5977C52.4668 18.181 52.5872 17.8359 52.8281 17.5625C53.069 17.2826 53.4173 17.0091 53.873 16.7422C53.3001 16.4948 52.8444 16.0977 52.5059 15.5508C52.1738 15.0039 52.0078 14.3594 52.0078 13.6172C52.0078 12.4258 52.3952 11.5046 53.1699 10.8535C53.9447 10.2025 55.0514 9.87695 56.4902 9.87695C56.7962 9.87695 57.1576 9.90625 57.5742 9.96484C57.9974 10.0169 58.2676 10.056 58.3848 10.082H62.1934ZM53.7656 22.543C53.7656 22.9531 53.9609 23.2754 54.3516 23.5098C54.7487 23.7441 55.3021 23.8613 56.0117 23.8613C57.0794 23.8613 57.916 23.7148 58.5215 23.4219C59.127 23.1289 59.4297 22.7285 59.4297 22.2207C59.4297 21.8105 59.2507 21.5273 58.8926 21.3711C58.5345 21.2148 57.9811 21.1367 57.2324 21.1367H55.6895C55.1426 21.1367 54.6836 21.2637 54.3125 21.5176C53.9479 21.778 53.7656 22.1198 53.7656 22.543ZM54.8496 13.6562C54.8496 14.2487 54.9831 14.7174 55.25 15.0625C55.5234 15.4076 55.9368 15.5801 56.4902 15.5801C57.0501 15.5801 57.4603 15.4076 57.7207 15.0625C57.9811 14.7174 58.1113 14.2487 58.1113 13.6562C58.1113 12.3411 57.571 11.6836 56.4902 11.6836C55.3965 11.6836 54.8496 12.3411 54.8496 13.6562ZM74.0781 21H71.0996V14.623C71.0996 13.8353 70.9596 13.2461 70.6797 12.8555C70.3997 12.4583 69.9538 12.2598 69.3418 12.2598C68.5085 12.2598 67.9062 12.5397 67.5352 13.0996C67.1641 13.653 66.9785 14.5742 66.9785 15.8633V21H64V10.082H66.2754L66.6758 11.4785H66.8418C67.1738 10.9512 67.6296 10.554 68.209 10.2871C68.7949 10.0137 69.459 9.87695 70.2012 9.87695C71.4707 9.87695 72.4342 10.222 73.0918 10.9121C73.7493 11.5957 74.0781 12.5853 74.0781 13.8809V21ZM95.5332 13.8418C95.5332 16.2051 94.9473 18.0215 93.7754 19.291C92.6035 20.5605 90.9238 21.1953 88.7363 21.1953C86.5488 21.1953 84.8691 20.5605 83.6973 19.291C82.5254 18.0215 81.9395 16.1986 81.9395 13.8223C81.9395 11.446 82.5254 9.63281 83.6973 8.38281C84.8757 7.1263 86.5618 6.49805 88.7559 6.49805C90.9499 6.49805 92.6263 7.12956 93.7852 8.39258C94.9505 9.6556 95.5332 11.472 95.5332 13.8418ZM85.1133 13.8418C85.1133 15.4368 85.416 16.638 86.0215 17.4453C86.627 18.2526 87.5319 18.6562 88.7363 18.6562C91.1517 18.6562 92.3594 17.0514 92.3594 13.8418C92.3594 10.6257 91.1582 9.01758 88.7559 9.01758C87.5514 9.01758 86.6432 9.42448 86.0312 10.2383C85.4193 11.0456 85.1133 12.2467 85.1133 13.8418ZM105.992 21L105.592 19.6035H105.436C105.117 20.1113 104.664 20.5052 104.078 20.7852C103.492 21.0586 102.825 21.1953 102.076 21.1953C100.794 21.1953 99.8268 20.8535 99.1758 20.1699C98.5247 19.4798 98.1992 18.4902 98.1992 17.2012V10.082H101.178V16.459C101.178 17.2467 101.318 17.8392 101.598 18.2363C101.878 18.627 102.324 18.8223 102.936 18.8223C103.769 18.8223 104.371 18.5456 104.742 17.9922C105.113 17.4323 105.299 16.5078 105.299 15.2188V10.082H108.277V21H105.992ZM116.002 18.8223C116.523 18.8223 117.148 18.7083 117.877 18.4805V20.6973C117.135 21.0293 116.223 21.1953 115.143 21.1953C113.951 21.1953 113.082 20.8958 112.535 20.2969C111.995 19.6914 111.725 18.7865 111.725 17.582V12.3184H110.299V11.0586L111.939 10.0625L112.799 7.75781H114.703V10.082H117.76V12.3184H114.703V17.582C114.703 18.0052 114.82 18.3177 115.055 18.5195C115.296 18.7214 115.611 18.8223 116.002 18.8223Z"
                fill="#E55858"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8775 2C13.7359 2 16.0615 4.32555 16.0615 7.18398V8.27313C16.0615 8.75694 15.6688 9.1496 15.185 9.1496C14.7012 9.1496 14.3085 8.75694 14.3085 8.27313V7.18398C14.3085 5.29082 12.7695 3.75293 10.8775 3.75293H5.18048C3.29082 3.75293 1.75293 5.29082 1.75293 7.18398V20.1895C1.75293 22.0815 3.29082 23.6194 5.18048 23.6194H10.8903C12.7741 23.6194 14.3085 22.0862 14.3085 20.2024V19.1004C14.3085 18.6166 14.7012 18.2239 15.185 18.2239C15.6688 18.2239 16.0615 18.6166 16.0615 19.1004V20.2024C16.0615 23.0538 13.7406 25.3723 10.8903 25.3723H5.18048C2.32438 25.3723 0 23.048 0 20.1895V7.18398C0 4.32555 2.32438 2 5.18048 2H10.8775ZM20.32 9.65911L23.7417 13.0656C23.7723 13.0959 23.7996 13.1274 23.8246 13.1607L23.7417 13.0656C23.7831 13.1065 23.82 13.1511 23.8519 13.1986C23.866 13.2202 23.8795 13.2425 23.8921 13.2654C23.9023 13.2833 23.9117 13.3019 23.9204 13.3209C23.9278 13.3377 23.9349 13.3545 23.9414 13.3715C23.9502 13.3938 23.9579 13.4166 23.9647 13.4397C23.9698 13.4579 23.9745 13.4761 23.9786 13.4945C23.9838 13.5168 23.9879 13.5393 23.9912 13.5619C23.993 13.5766 23.9948 13.5921 23.9962 13.6076C23.9988 13.6342 24 13.6602 24 13.6862L23.994 13.7586L23.9916 13.805C23.9914 13.807 23.9911 13.809 23.9908 13.811L24 13.6862C24 13.751 23.9928 13.8153 23.9789 13.8777C23.9745 13.8962 23.9698 13.9144 23.9646 13.9323C23.9579 13.9558 23.9502 13.9786 23.9416 14.0011C23.9349 14.0178 23.9278 14.0346 23.9202 14.0511C23.9117 14.0704 23.9023 14.0891 23.8922 14.1074C23.8795 14.1299 23.866 14.1522 23.8515 14.1738C23.8433 14.1866 23.8343 14.1992 23.8249 14.2116C23.7971 14.2482 23.7668 14.2827 23.734 14.3146L20.32 17.7144C20.1494 17.885 19.925 17.9703 19.7018 17.9703C19.4775 17.9703 19.2519 17.885 19.0813 17.7121C18.7401 17.3685 18.7412 16.8146 19.0836 16.4733L21 14.5626H9.05187C8.56806 14.5626 8.17541 14.17 8.17541 13.6862C8.17541 13.2024 8.56806 12.8097 9.05187 12.8097H21.0024L19.0836 10.9002C18.7412 10.5589 18.7389 10.005 19.0813 9.66145C19.4225 9.31788 19.9765 9.31788 20.32 9.65911Z"
                fill="#E55858"
              />
            </svg>
          </Box>
        </Grid>
      </Grid>
      <Grid
        item
        md={9}
        sx={{
          minHeight: '100vh',
          background: (t) => t.palette.background.default,
          // paddingRight: '1rem',
        }}
      >
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default Layout;
